import Debug from 'debug';
import { inject } from '@angular/core';
import { 
  ActivatedRouteSnapshot, 
  Router,
  RedirectCommand, 
  Resolve,
  UrlTree
} from '@angular/router';
import { NoteService } from '../services/note_service';
import { UserService } from '../services/user_service';
import { StreamService } from '../services/stream_service';
import { Note } from '../types/note';
import { Observable } from 'rxjs';

const debug = Debug('notd:NoteResolve');

type NoteResolveResult = Note | null | RedirectCommand;

export class NoteResolve implements Resolve<NoteResolveResult | Observable<NoteResolveResult> | Promise<NoteResolveResult>> {

  private noteService = inject(NoteService);
  private userService = inject(UserService);
  private streamService = inject(StreamService);
  private router = inject(Router);

  resolve(
    route: ActivatedRouteSnapshot, 
  ): Promise<NoteResolveResult> { 
    const notFoundUrl: UrlTree = this.router.parseUrl('/404');
    
    if (route.params['custom-url']) {
      const customUrl = route.params['custom-url'];
      debug('resolve customUrl', customUrl);
      
      return this.noteService.getNoteIdFromCustomUrl(customUrl).then(
        result => {
          if (!result || !result.post || !result.post.id) {
            console.error('No custom url found or empty result, redirect to 404');
            return new RedirectCommand(notFoundUrl);
          }
          return this.getNoteInfo(result.post.id);
        },
        err => {
          console.error('No custom url found, redirect to 404', err);
          return new RedirectCommand(notFoundUrl);
        }
      )
      .catch(err => {
        console.error('No custom url found, redirect to 404', err);
        return new RedirectCommand(notFoundUrl);
      });
    } else {
        debug('resolve id', route.params['id']);
        return this.getNoteInfo(route.params['id']);
    }
  }

  private getNoteInfo(noteId: string): Promise<Note | null | RedirectCommand> {
    
    const notFoundUrl: UrlTree = this.router.parseUrl('/404');
    const rootUrl: UrlTree = this.router.parseUrl('/');

    return this.noteService.getNoteInfo(noteId, true).then(
      (note: Note) => {
        const promisesArray = [];
        const promisesMap: ('user' | 'stream')[] = [];

        debug('getNoteInfo id:', noteId);

        if (!note.user && note.userId) {
          promisesArray.push(this.userService.getUserProfile(note.userId));
          promisesMap.push('user');
        }

        if (!note.stream && note.channelId) {
          promisesArray.push(this.streamService.getStreamInfo(note.channelId));
          promisesMap.push('stream');
        }

        // Użycie Promise.all
        return Promise.all(promisesArray).then((res) => {
            note.comments = [];
            res.forEach((result, i) => {
              note[promisesMap[i]] = result; 
            });
            return note;
        }, () => note)
        .catch(err => {
          console.error('Error while fetching additional note data', err);
          return new RedirectCommand(notFoundUrl);
        });
      },
      err => {
        if (err && err.status === 404) {
            return new RedirectCommand(notFoundUrl);
        }
        return new RedirectCommand(rootUrl);
      }
    ).catch(err => {
      console.log(err);
      return new RedirectCommand(notFoundUrl);
    });
  }
}
